import { mapGetters, mapActions } from 'vuex'

const moduleName = 'vehicles'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff'
    }),
    ...mapGetters('vehicleOptions', {
      storeBodyShapes: 'bodyShapes',
      storeColours: 'colours',
      storePaintGroups: 'paintGroups'
    }),
    ...mapGetters(['licenceExpired'])
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'addStoreItem', 'saveSnapshot', 'clearSnapshots', 'setReturnRoute']),
    ...mapActions('vehicleOptions', ['refreshColour']),
    ...mapActions('customers', {setCustomerReturnRoute: 'setReturnRoute',editStoreCustomer: 'editStoreItem',addStoreCustomer: 'addStoreItem'}),
    ...mapActions('quotes', {setQuoteVehicleCustomer: 'setVehicleCustomer'}),
    ...mapActions('printpreview', { setPrintPreviewReturnRoute: 'setReturnRoute', addEmailer: 'addEmailer', removeEmailer: 'removeEmailer' }),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', removeReportParameters: 'removeParameters' })
  }
}
